<template>
  <div class="navigation">
    <div class="border-img-box">
      <img
        v-if="exhibitionInfo && exhibitionInfo.logo"
        :src="exhibitionInfo.logo"
        v-load="'oAvatarSmall'"
      />
      <img
        v-else
        src="https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3620016507,562397260&fm=111&gp=0.jpg"
      />
      <div class="nav-info" v-if="exhibitionInfo">
        <div class="nav-info-top">
          <div class="nav-info-txt">{{exhibitionInfo.name}}</div>
        </div>
        <div class="nav-info-bottom">
          <div class="nav-info-txt">主题线上展</div>
        </div>
      </div>
      <div class="nav-btn" :class="isFollow?'love':''" @click="setCollect()">{{isFollow ? '已关注': '关注'}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "navigation",
  props: {
    navType: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isShow: false ,// 授权弹框
      isFollow: false ,
    };
  },
  computed: {
    ...mapGetters({
      IsHasGetUser: "getIsHasGetUser", 
      hostInfo: "getHostInfo",
      roomid: "getRoomid",
      roomInfo: "getRoomInfo",
      userId: "getUserId",
      userInfo:'getUserInfo',
      exhibitionId: "getExhibitionId", 
      exhibitionInfo: "getExhibitionInfo",
    }), 
  },
  created() {
    this.init(); 
  },
  methods: {
    ...mapActions({
      getCurrentUrl: "init/getCurrentUrl",
      getCheck: "getCheck",
      follow: "follow",
      cancelFollow: "cancelFollow",
      addExhibitionFollower: "addExhibitionFollower",
      authenticateOidcSilent: "authenticateOidcSilent",
    }),
    async init() { 
      this.isFollow = await this.getCheck({ExhibitionId: this.exhibitionId, UserId: this.userId}); 
    },
    close(msg) {
      this.isShow = msg;
    },
    async setCollect() {
      this.authenticateOidcSilent();
      return;
      if (this.userInfo.userRole==0){     //判断是不是游客
        this.$toast.fail("请前往注册");
      }else{
        let req = {
          ExhibitionId: this.exhibitionId,
          UserId: this.userId
        };
        if (!this.isFollow) {
          let res = await this.follow(req);
          if (res && res.result) {
            this.$toast.success("关注成功");
            this.isFollow = true;
          } else {
            this.$toast.fail({
              message: "关注失败！",
              duration: 1500
            });
          }
        } else {
          let res = await this.cancelFollow(req);
          if (res && res.result) {
            this.$toast.success("取消成功");
            this.isFollow = false;
          } else {
            this.$toast.fail({
              message: "取消失败！",
              duration: 1500
            });
          }
        }
      }

    }
  }
};
</script>

<style scoped lang="scss">
.nav-box {
  overflow: hidden;
}

.status-bar,
.navigation-bar,
.navigation,
.menu {
  position: absolute;
  z-index: 99;
  transition: 0.3s;
  width: 100%;
  top: 0.21rem;
  left: 0.2rem;
}

.navigation {
  display: flex;
  align-items: center;
  height: 0.64rem;
  width: 3.8rem;
  
}

.status-bar {
  background-color: transparent;
}

.navigation-bar {
  background-color: transparent;
}

.title {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #2c2b2b;
}

.border-img-box {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0.64rem;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 3.8rem;
  height: 100%;
  padding: 0 0.08rem;
}

.border-img-box img {
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 50%;
  margin-right: 0.14rem;
}

.border-img-box .txt {
  font-size: 12px;
  color: #000;
}

.nav-info {
  display: flex;
  width: 1.74rem;
  margin-right: 0.26rem;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 0.02rem 0 0;
}

.nav-info-txt {
  width: calc(100% - 1px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav-info-top {
  width: 100%;
  line-height: 1.2;
  color: #fff;
  .nav-info-txt{
    font-size: 0.2rem;
  }
}

.nav-info-bottom {
  width: 100%;
  font-size: 0.16rem;
  color: #fff;
  line-height: 1.2;
  margin-top: 0.05rem;
  .nav-info-txt{
    font-size: 0.16rem;
  }
}

.nav-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.5rem;
  background-color: #f85b0f;
  border-radius: 0.42rem;
  font-size: 0.24rem;
  color: #fff;
  text-align: center;
  border: 1px solid #f85b0f;
  flex: 1;
  &.love{
    color: #f85b0f;
    background-color: transparent;
  }
}

.nav-txt {
  font-size: 0.3rem;
  color: #333;
  text-align: center;
}
</style>
